/* eslint-disable */
import { shape_definition_representation } from '@bldrs-ai/conway/src/AP214E3_2010/AP214E3_2010_gen/shape_definition_representation.gen';
import { product } from '@bldrs-ai/conway/src/AP214E3_2010/AP214E3_2010_gen/product.gen';
export class AP214Properties {
    constructor(api) {
        this.api = api;
    }
    getIfcType(type) {
        return '';
    }
    async getItemProperties(id, recursive = false) {
        return this.api.getLine(id, recursive);
    }
    async getPropertySets(elementID, recursive = false) {
        return [];
    }
    async getTypeProperties(elementID, recursive = false) {
        return [];
    }
    async getMaterialsProperties(elementID, recursive = false) {
        return [];
    }
    async getSpatialStructure(includeProperties) {
        const model = this.api.StepModel;
        const products = Array.from(model.types(product));
        const productObj = products[0];
        const productNode = AP214Properties.newAP214Product(productObj.expressID);
        const shapeDefinitions = model.types(shape_definition_representation);
        for (const shapeDefinition of shapeDefinitions) {
            const nodeExpressID = shapeDefinition.expressID;
            if (nodeExpressID !== void 0) {
                productNode.children.push({
                    expressID: nodeExpressID,
                    type: 'shape_definition',
                    children: [],
                });
            }
        }
        return productNode;
    }
    async getAllItemsOfType(type, verbose) {
        return [];
    }
    static newAP214Product(id) {
        return {
            expressID: id,
            type: 'product',
            children: [],
        };
    }
}
